import axios from "axios";
import AlertStore from '@/stores/AlertStore'
import hasPermission from "../filters/hasPermission";
import {
  ENDPOINT_EXPORT,
  ENDPOINT_MARCHE_EFFECTIF_INFOS,
  ENDPOINT_MARCHE_EFFECTIF_INFOS_VALIDATE,
  ENDPOINT_SEARCH,
  ENDPOINT_SEARCH_LATEST_MARCHE,
  ENDPOINT_EXPORT_HEURE,
  ENDPOINT_MARCHE_EFFECTIF_INFOS_REJECT
} from "../constants/endpoints";

let store = {
  debug: true,

  get(id) {
    return axios
        .get(ENDPOINT_MARCHE_EFFECTIF_INFOS + '/' + id)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  create({pieceJustificative, ...effectifInfos}) {
    const formData = new FormData()
    formData.append('data', new Blob([JSON.stringify(effectifInfos)], {
      type: "application/json"
    }))
    formData.append('file', pieceJustificative)
    return axios
        .post(ENDPOINT_MARCHE_EFFECTIF_INFOS, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {
          AlertStore.pushSuccess('Données d\'effectifs créées avec succès.');
          this.clearLocalStorage();
        })
        .catch(error => {
          if (error.response) {
            AlertStore.pushError(error.response.data.message);
          } else {
            AlertStore.pushError("Une erreur est survenue lors de la sauvegarde de la pièce justificative. " +
              "Merci de vérifier qu'elle ne dépasse pas 5MB.")
          }
        })
  },

  update(effectifInfos) {
    return axios
        .put(ENDPOINT_MARCHE_EFFECTIF_INFOS, effectifInfos)
        .then(() => {
          const isAdmin = hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR']);
          const correspondantMsg = "Modification de données d'effectifs soumise pour approbation.";
          const adminMsg = "Données d'effectifs modifiées avec succès.";
          const successMessage = isAdmin || !effectifInfos.jourSoumissionPassed ? adminMsg : correspondantMsg;
          AlertStore.pushSuccess(successMessage);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  delete(effectifInfos) {
    return axios
        .delete(ENDPOINT_MARCHE_EFFECTIF_INFOS + '/' + effectifInfos.id)
        .then(() => {
          const isAdmin = hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR']);
          const correspondantMsg = "Suppression de données d'effectifs soumise pour approbation.";
          const adminMsg = "Données d'effectifs supprimées avec succès.";
          const successMessage = isAdmin || effectifInfos.statut === 'ATTENTE_MODIFICATION' || !effectifInfos.jourSoumissionPassed ? adminMsg : correspondantMsg;
          AlertStore.pushSuccess(successMessage);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  search(effectifInfos, pageIndex, pageSize, sortOptions) {
    const recherche = this.effectifInfosToRecherche(effectifInfos);
    let url = `${ENDPOINT_MARCHE_EFFECTIF_INFOS + ENDPOINT_SEARCH}?page=${pageIndex}&size=${pageSize}`;
    if (sortOptions) {
      for (const sortOption of sortOptions) {
        url += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`;
      }
    }
    return axios
        .post(url, recherche);
  },

  export(effectifInfos) {
    const recherche = this.effectifInfosToRecherche(effectifInfos);
    let url = `${ENDPOINT_MARCHE_EFFECTIF_INFOS + ENDPOINT_EXPORT}`;
    return axios
        .post(url, recherche);
  },

  exportHeure(data) {
      const startFormatedDate = `${data.startDate.getFullYear()}-${(data.startDate.getMonth() + 1)}-${data.startDate.getDate()}`
      const endFormatedDate = `${data.endDate.getFullYear()}-${(data.endDate.getMonth() + 1)}-${data.endDate.getDate()}`
      let url = `${ENDPOINT_MARCHE_EFFECTIF_INFOS + ENDPOINT_EXPORT_HEURE}?startDate=${startFormatedDate}&endDate=${endFormatedDate}`;
      return axios.get(url);
  },

  validate(effectifInfos) {
    return axios
        .post(ENDPOINT_MARCHE_EFFECTIF_INFOS_VALIDATE + '/' + effectifInfos.id)
        .then(() => {
          const operation = effectifInfos.statut === 'ATTENTE_MODIFICATION' ? 'modification' : 'suppression';
          AlertStore.pushSuccess(`Demande de ${operation} de données d'effectifs approuvée avec succès.`);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  reject(id, commentaire) {
    return axios.post(`${ENDPOINT_MARCHE_EFFECTIF_INFOS_REJECT}/${id}`, {
      message: commentaire
    })
      .then((response) => {
        if (response.status === 204) {
          AlertStore.pushSuccess('La saisie d\'effectif a été rejetée avec succès.')
        }
      }).catch(() => {
        AlertStore.pushError('La saisie d\'effectif n\'a pas pu être rejetée.')
      })
  },

  getLatestByMarcheAndStatuts(marcheId, date) {
    const url = `${ENDPOINT_MARCHE_EFFECTIF_INFOS + ENDPOINT_SEARCH_LATEST_MARCHE}`;
    return axios.get(url, {params: {marcheId, date}})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        });
  },

  effectifInfosToRecherche(effectifInfos) {
    let recherche = [];
    recherche.push({key: 'marche', operation: '=', value: effectifInfos.marche});
    recherche.push({key: 'ligne', operation: '=', value: effectifInfos.ligneId});
    recherche.push({key: 'statut', operation: '€', value: effectifInfos.statut});
    recherche.push({key: 'date', operation: '>=', value: effectifInfos.dateDebut});
    recherche.push({key: 'date', operation: '<=', value: effectifInfos.dateFin});
    return recherche;
  },
  clearLocalStorage() {
    localStorage.removeItem('effectifInfos');
    localStorage.removeItem('dateEffectifInfos');
    localStorage.removeItem('marcheAdminEffectifInfos');
  }
};

export default store;
